import { Box, CircularProgress, Typography } from '@mui/material';
import { ButtonProps as MuiButtonProps } from '@mui/material/Button';
import { Theme, useTheme } from '@mui/material/styles';

export type LelySpinnerProps = {
  variant?: MuiButtonProps['variant'];
  label?: string;
};

function LelySpinner({ variant, label }: LelySpinnerProps) {
  const theme = useTheme();
  const loadingIndicatorSize = theme.lelySpacing.LG;
  const loadingIndicatorThickness = 5;
  const loadingIndicatorTrackOpacity = theme.palette.action.disabledOpacity;
  const loadingIndicatorColor = variant === 'primary' ? 'default' : 'primary';
  const getLoadingIndicatorColor = (theme: Theme) =>
    variant === 'primary'
      ? theme.palette.text.light
      : theme.palette.text.brandPrimary;
  const spinner = (
    <Box
      component="span"
      sx={{
        position: 'relative',
        display: 'inline-flex',
        width: loadingIndicatorSize,
        height: loadingIndicatorSize,
      }}
    >
      <CircularProgress
        aria-hidden
        color={loadingIndicatorColor}
        size={loadingIndicatorSize}
        thickness={loadingIndicatorThickness}
        value={100}
        variant="determinate"
        sx={(theme) => ({
          color: getLoadingIndicatorColor(theme),
          opacity: loadingIndicatorTrackOpacity,
        })}
      />
      <CircularProgress
        color={loadingIndicatorColor}
        size={loadingIndicatorSize}
        data-testid="loading-indicator"
        thickness={loadingIndicatorThickness}
        sx={(theme) => ({
          color: getLoadingIndicatorColor(theme),
          position: 'absolute',
          left: 0,
        })}
      />
    </Box>
  );

  if (!label) {
    return spinner;
  }

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
      }}
    >
      {spinner}
      <Typography variant="xs">{label}</Typography>
    </Box>
  );
}

export default LelySpinner;
